'use strict';

module.exports = {
  getLocales() {
    return this.getLocalesWithNames().map(i => i.locale);
  },

  getLocalesWithNames() {
    return [
      { locale: 'de', name: 'Deutsch' },
      { locale: 'en', name: 'English' },
      { locale: 'es', name: 'Español' },
      { locale: 'fr', name: 'Français' },
      { locale: 'it', name: 'Italiano' },
      { locale: 'nb_NO', name: 'Norsk' },
      { locale: 'nl', name: 'Nederlands' },
      { locale: 'ru', name: 'Русский' },
      { locale: 'zh_CN', name: '中文(简体)' }
    ];
  },

  isLocaleSupported(locale) {
    return this.getLocales().includes(locale);
  }
};

